import { useNavigate } from "react-router-dom";

import { Link, Text } from "@bps/fluent-ui";
import {
  FieldDeviceClaim,
  KnownClaimKeys
} from "@libs/api/gateways/field/field-ops-gateway.dtos";

interface ClaimsValueDisplayProps {
  claim: FieldDeviceClaim;
}

export const ClaimsValueDisplay = ({ claim }: ClaimsValueDisplayProps) => {
  const navigate = useNavigate();

  if (
    claim.key === KnownClaimKeys.ServerTenantId ||
    claim.key === KnownClaimKeys.ClientTenantId
  ) {
    return (
      <Link onClick={() => navigate(`/tenants/${claim.value}/plt-detail`)}>
        {claim.value}
      </Link>
    );
  }

  return <Text>{claim.value}</Text>;
};
